import { gql } from '@apollo/client';

/**
 * Actor GraphQL Fragment - All 68 fields
 */
export const ACTOR_FIELDS_FRAGMENT = gql`
  fragment ActorFields on Actor {
    # Identity (9)
    id
    tenantId
    name
    version
    actorType
    category
    domain
    instanceName
    authUserId

    # Definition & Capabilities (7)
    description
    capabilities
    requiredPermissions
    configuration
    role
    primaryRoleId
    roleIds

    # Formula Interaction (7)
    assignedTaskIds
    workflowInstanceId
    queueIds
    formulaParticipation
    taskCompletionRate
    avgTaskResponseMinutes
    avgTaskResolutionMinutes

    # Runtime State (11)
    status
    available
    currentWorkflowId
    currentTaskId
    workload
    maxCapacity
    peakWorkload
    lastActivityAt
    totalTimeActiveSeconds
    totalTimeIdleSeconds
    lastStatusChangeAt

    # Expert/AI Specific (13)
    expertTier
    specializations
    certifications
    yearsExperience
    licenseNumber
    licenseJurisdiction
    model
    provider
    averageConfidence
    accuracyOnTestSet
    requiresHumanOversight
    autonomyLevel
    supervisedByActorId

    # Performance & Metrics (12)
    totalTasksCompleted
    totalTasksFailed
    completedTasksLast24h
    failedTasksLast24h
    avgCompletionTimeSeconds
    successRate
    circuitBreakerOpen
    circuitBreakerOpenedAt
    circuitBreakerFailureCount
    circuitBreakerThreshold
    circuitBreakerTimeoutSeconds
    circuitBreakerResetCount

    # Safety & Reliability (6)
    timeoutSeconds
    maxRetries
    backoffSeconds
    backoffMultiplier
    maxBackoffSeconds
    maxConcurrency

    # Compliance & Regulatory (8)
    regulatoryClearance
    regulatoryTags
    criticalityLevel
    requiresSupervision
    requiresDualControl
    dualControlCapable
    accessLevel
    retentionYears

    # Task Assignment (3)
    lastAssignedAt
    lastAssignedBy
    lastAssignmentType

    # Contact & Organization (4)
    teamId
    supervisorId
    contactInfo
    preferences

    # Lifecycle & Audit (12)
    active
    deprecated
    deprecationReason
    deprecationDate
    lastModifiedReason
    lastStatusChangeReason
    parentId
    createdAt
    updatedAt
    createdBy
    updatedBy
    auditVersion

    # Metadata & Extensibility (2)
    tags
    metadata

    # Append-Only Architecture (2)
    originalId
    recordVersion
  }
`;
